// The owner's Study 02 picks (2026-10-11). Where each file comes from:
// public/sounds/slope/README.md. The earlier Soft & snowy and Crisp & sporty
// palettes remain in tools/sound-lab/catalog.cjs; see that folder's README.
//
// volume is the Howl gain that puts each cue on its agreed level at master
// volume 1.0: level = file loudness + 20*log10(volume), in dBFS, where loudness
// is the loudest 400 ms RMS (tools/sound-lab/audio/v2/shipped-mix.json).
export const soundPalette = {
  click: { src: '/sounds/slope/tap.wav', volume: 0.146 }, // -15.3 dBFS file -> -32 dB
  betPlace: { src: '/sounds/slope/wager-accepted.wav', volume: 0.251 }, // -15.0 -> -27
  cashout: { src: '/sounds/slope/cashout.wav', volume: 0.48 }, // -14.6 -> -21
  reject: { src: '/sounds/slope/reject.wav', volume: 0.336 }, // -18.5 -> -28
  milestone: { src: '/sounds/slope/milestone.wav', volume: 0.443 }, // -15.9 -> -23
  crash: { src: '/sounds/slope/wipeout.wav', volume: 0.74 }, // -14.4 -> -17
} as const;
